import Vue from 'vue';

import 'vue.directives';
import 'vue.components';
import 'vue.filters';
import 'vue.mixins';
import _ from 'lodash-extended';

Object.assign(Vue.prototype, {
  /**
   * print to console plain objects (should be plane non-recursive object) without get/set wrappers
   * that added by Vuejs so you'll no see {...} or (...) in dev-tools
   * @param args
   */
  $log(...args) {
    for (let n = 0, N = args.length; n < N; n++) {
      if (_.isPlainObject(args[n]) || _.isArray(args[n])) {
        args[n] = JSON.parse(JSON.stringify(args[n]));
      }
    }
    console.log(...args);
  },

  /**
   * Update properties from source to destination
   * @param destination {Object}
   * @param source {Object}
   */
  $$set(destination, source) {
    if (_.isPlainObject(destination) && _.isPlainObject(source)) {
      for (const prop in source) {
        if (Object.getOwnPropertyDescriptor(source, prop)) {
          Vue.set(destination, prop, source[prop]);
        }
      }
    }
  },

  /**
   * Assign single change listener for multiple properties
   * enspired by https://github.com/vuejs/vue/issues/844#issuecomment-373474194
   * @param props {Array<String>}
   * @param callback {Function}
   * @param [options] {{immediate, deep}}
   */
  $watchAny(props, callback, options) {
    const invokeNow = options && options.immediate;
    options = options || {};
    options.immediate = false;

    props.forEach((prop) => {
      // Pass the prop as the first argument to our callback
      this.$watch(prop, callback.bind(null, prop), options);
    });

    if (invokeNow) {
      callback.call(null);
    }
  },
  _,
});

console.$log = Vue.prototype.$log;
Vue.$$set = Vue.prototype.$$set;
